'use client';
import './Category.css';
import { useRouter } from 'next/navigation';
import SearchBar from '../../../components/SearchBar/SearchBar';
import categories from '../../../config/categories.json';
import { BottomAds, HomePageBottomResAds } from '@/components/Ads/homepage_ads';

const Category = () => {
  const router = useRouter();

  const iconMap = {
    lifeInGermany: '/images/Category/lifeInGermany.png',
    movingIcon: '/images/Category/moving.png',
    immigrationIcon: '/images/Category/immigration.png',
    germanIcon: '/images/Category/germanIcon.png',
    financesIcon: '/images/Category/finances.png',
    entrepreneurship: '/images/Category/entrepreneurship.png',
  };

const handleCategoryClick = (categoryObj) => {
  router.push(`/blogs/${categoryObj.slug}`);
};

  return (
    <div className="link-section-container">
      <h2 className="link-section-title">Essential Resources for the Indian Community in Munich</h2>

      <div className="searchFlex">
        <div className="searchBar">
          <SearchBar />
        </div>
      </div>

      <div className="link-section-grid">
        {categories.map((link) => (
          <div
            key={link.id}
            className="link-item"
            onClick={() => handleCategoryClick(link)}
          >
            <div className="link-content">
              <img
                src={iconMap[link.icon]}
                alt={link.text}
                className="link-icon"
              />
              <span className="span">{link.text}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="ads">
        <BottomAds />
        <HomePageBottomResAds />
      </div>
    </div>
  );
};

export default Category;
